// extracted by mini-css-extract-plugin
export default {"metrics_pm":"MemorandumValues_metrics_pm__Z8xnq","column_metrics":"MemorandumValues_column_metrics__R6WT5"};